import Link from "next/link";
import MainLayout from "@/Component/MainLayout";
import { withRegionPath } from "@/utils/session";
import styles from "./NotFound.module.css";

export default function NotFound() {
  return (
    <MainLayout hideHeader>
      <div className={`standard-padding ${styles.page}`}>
        <p className={styles.code} aria-hidden="true">
          404
        </p>
        <h1 className={styles.title}>Page not found</h1>
        <p className={styles.desc}>
          The page you are looking for does not exist or may have been moved.
          Check the URL or return to the homepage.
        </p>
        <Link href={withRegionPath("/holiday")} className={styles.button}>
          Go to Homepage
        </Link>
      </div>
    </MainLayout>
  );
}
